import { render, staticRenderFns } from "./RemovePerson.vue?vue&type=template&id=43b469a0"
import script from "./RemovePerson.vue?vue&type=script&lang=ts"
export * from "./RemovePerson.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports